import { useFilterTerminationTypeContext } from "./filter-termination-type.context";

export function FilterTerminationType() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterTerminationTypeContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}